export default __webpack_public_path__ + "static/media/cmake.c6182d9e.png";